import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import "./assets/style.css";

import { HashRouter, Routes, Route, Link } from "react-router-dom";
import Header from "./components/layout/Header";
import Home from "./components/pages/Home";
import Footer from "./components/layout/Footer";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import ContactUs from "./components/pages/ContactUs";
import TermsOfUse from "./components/pages/TermsOfUse";
import EULA from "./components/pages/EULA";
import KPI from "./components/pages/products/KPI";
import EmployeeDirectory from "./components/pages/products/EmployeeDirectory";
import HelpDesk from "./components/pages/products/HelpDesk";
import ScrumMaster from "./components/pages/products/ScrumMaster";
import AppConstants from "./common/AppConstants";
import CommonMethods from "./common/CommonMethods";
import KpiDocumentation from "./components/pages/documentation/KpiDocumentation";
import EmployeeDirectoryDocumentation from "./components/pages/documentation/EmployeeDirectoryDocumentation";
import HelpDeskDocumentation from "./components/pages/documentation/HelpDeskDocumentation";
import ScrumMasterDocumentation from "./components/pages/documentation/ScrumMasterDocumentation";

function App() {
  const [isLoaded, setsLoaded] = useState(true);
  useEffect(() => {
    AOS.init({ duration: 1200, once: false, mirror: true });

    var listener = (e: any) => {
      AOS.refresh();
    };

    try {
      CommonMethods.logSiteVisit();
    } catch {}

    window.addEventListener("load", listener);

    return () => {
      window.removeEventListener("load", listener);
    };
  }, []);
  return (
    <>
      <HashRouter>
        <Header />
        <Routes>
          <Route path={AppConstants.Views.Home} element={<Home />} />
          <Route path={AppConstants.Views.Products.KPI} element={<KPI />} />
          <Route
            path={AppConstants.Views.Products.Directory}
            element={<EmployeeDirectory />}
          />
          <Route
            path={AppConstants.Views.Products.HelpDesk}
            element={<HelpDesk />}
          />
          <Route
            path={AppConstants.Views.Products.ScrumMaster}
            element={<ScrumMaster />}
          />
          <Route path={AppConstants.Views.ContactUs} element={<ContactUs />} />
          <Route
            path={AppConstants.Views.PrivacyPolicy}
            element={<PrivacyPolicy />}
          />
          <Route
            path={AppConstants.Views.TermsOfUse}
            element={<TermsOfUse />}
          />
          <Route path={AppConstants.Views.EULA} element={<EULA />} />
          <Route
            path={AppConstants.Views.Documentation.KPI}
            element={<KpiDocumentation />}
          />
          <Route
            path={AppConstants.Views.Documentation.Directory}
            element={<EmployeeDirectoryDocumentation />}
          />
          <Route
            path={AppConstants.Views.Documentation.HelpDesk}
            element={<HelpDeskDocumentation />}
          />
          <Route
            path={AppConstants.Views.Documentation.ScrumMaster}
            element={<ScrumMasterDocumentation />}
          />
          <Route element={<Home />} />
        </Routes>
        <Footer />
      </HashRouter>
    </>
  );
}

export default App;
